import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import Modal from '../../../Modal2/Modal';
import Button from '../../../button/Button';
import { Paragraph } from '../../../typography';

import useChatDispatchActions from '../../../../customHooks/useChatDispatchActions';
import { REMOVE_INTERNAL_CHAT_GROUP } from '../../../../helpers/internalChatConstants';
import { messageGroupsService } from '../../../../newServices/corporateChat';
import { getApiErrorMessage } from '../../../../utils/internalChatGroups';

import internalChatToast from '../../utils/internalChatToast';

const DeleteGroupModal = ({ show, group, onClose }) => {
    const intl = useIntl();
    const dispatchChatActions = useChatDispatchActions();

    const [deleting, setDeleting] = useState(false);

    const handleClose = () => {
        if (!deleting) onClose();
    }

    /** A exclusão é lógica, e a listagem não traz grupo excluído: ele sai da lista na
     *  hora, pelo id, sem depender do corpo da resposta. A janela fecha junto.
     */
    const handleConfirm = async () => {
        setDeleting(true);
        try {
            await messageGroupsService.deleteMessageGroup(group.id);
            internalChatToast.success(intl.formatMessage({ id: "Grupo excluído com sucesso!" }));
            setDeleting(false);
            onClose();
            dispatchChatActions(REMOVE_INTERNAL_CHAT_GROUP, group.id);
        } catch (error) {
            internalChatToast.error(
                getApiErrorMessage(error) || intl.formatMessage({ id: "Não foi possível excluir o grupo. Tente novamente." })
            );
            setDeleting(false);
        }
    }

    return (
        <Modal
            show={show}
            toggle={handleClose}
            position="center"
            size="sm"
            onPressEnter={() => {}}
        >
            <Modal.Header>{intl.formatMessage({ id: "Excluir grupo" })}</Modal.Header>
            <Modal.Content>
                <div className="p-1">
                    <Paragraph color="gray" light>
                        <FormattedMessage
                            id="Ao excluir o grupo {group}, ele sai da lista de conversas de todos os participantes e ninguém poderá mais enviar mensagens nele. Confirma a exclusão?"
                            values={{ group: <b>{group?.name}</b> }} />
                    </Paragraph>
                </div>
            </Modal.Content>
            <Modal.Footer>
                <div className="d-flex justify-content-between">
                    <Button.Cancel
                        disabled={deleting}
                        onClick={handleClose} />
                    <Button.Danger
                        disabled={deleting}
                        loading={deleting}
                        onClick={handleConfirm}>
                        {intl.formatMessage({ id: "Excluir" })}
                    </Button.Danger>
                </div>
            </Modal.Footer>
        </Modal>
    );
};

export default DeleteGroupModal;
